import selectKeys from './selectKeys'

const handlerToCallUpdateIfValid = (update, props) => store => (...keys) => () => {
	if (Object.values(selectKeys(...keys)(store.validations)).every(validation => validation === undefined)) {
		update({
			values: {
				...selectKeys(...keys)(store.values)
			},
			...props
		})
	}
}

export default handlerToCallUpdateIfValid



// WEBPACK FOOTER //
// ./src/utilities/Data/handlerToCallUpdateIfValid.js